module.exports = __webpack_public_path__ + "img/flag_en.8a08d838.jpg";